import { tokens } from "@swiggy-private/dls-web-common/dist/components/tokens";

export const EXPRIRING_SAVINGS_TEXTS = {
    MESSAGE: "(expires in {0} days)",
    TOOLTIP_CONTENT: "off on next order",
    TOOLTIP_BODY: "This discount will get applied automatically when you order again within {0} days.",
};

export const COUPON_CARD_CTA_TEXTS = {
    MORE: "+ MORE",
    APPLY: "APPLY",
};

export const INPUT_BOX_PLACEHOLDER = "Enter Coupon Code";

export const DOUBLE_OFFER_COUPON_TYPE = "COUPON_TYPE_DOUBLE_OFFER";

export const APPLYING_COUPON_LOADER_TEXT = "Applying Coupon";
export const REMOVING_COUPON_LOADER_TEXT = "Removing Coupon";

export const COUPONLISTING_BOTTOMSHEET_CTA = "Back";
export const PAYMENT_COUPONLISTING_BOTTOMSHEET_CTA = "Don’t Apply this Coupon";
export const UNLOCK = "Unlock";

export const TD_COUPON_MODAL = {
    TD_COUPON_MODAL: "tdCouponModal",
    VALUE_MEALS: {
        TITLE: `<span style='color: ${tokens.colors.green1};'><span style="font-weight: 600;">Value Meals</span></span>`,
        SUBTEXT: "savings on this order",
    },
};

export const COUPON_CARD_GROUP_NEW_LOTTIE_MAXLIMIT = 15;
